import React, { useCallback, useRef, useState } from 'react';
import { Dialog, DialogContent, Typography, DialogActions, Button,/* useMediaQuery, useTheme,*/ DialogTitle, SxProps, Theme, Box, IconButton, useMediaQuery, useTheme, LinearProgress, Fade } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { QuestionsForm } from './QuestionsForm'
//import { HeaderContent } from '../../app/sharedcomponents';
//import { useDispatch } from 'react-redux';
import Slide from '@mui/material/Slide';
import { TransitionProps } from '@mui/material/transitions'
import { ProfileDialogTitle } from './ProfileDialogTitle'
//import { SearchState, getSearchStateFromPayload, getSearchByTerm } from '../../features/searchSlice'
import { useForm, /*SubmitHandler, Controller, */FormProvider } from 'react-hook-form';
import StepProgressBar from './StepProgressBar';
import { CircularProgressCentered } from '../../app/components/sharedcomponents'
//import { ReactJSXElement } from '@emotion/react/types/jsx-namespace';
import { StepType } from './QuestionsForm'
import { ErrorMessage } from "@hookform/error-message"
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export interface StepIndexUpdateType { stepIndex: number, isUpdated: boolean, steps: StepType[] }
export interface UpdateStepArgsType { formData: any, sumbitAattribute: string | undefined | null, stepIndexUpdate: StepIndexUpdateType, methods: any }

interface WizardDialogProps {
  //UpdateWizardData : ( arg: any) => void
  formData: any
  defaultFormDataformData: any
  updatedData: any
  open: boolean
  onClose: (args: UpdateStepArgsType) => void
  updateStep: (arg: UpdateStepArgsType) => any
  handleBack: () => void,
  handleSkip?: (methods: any) => void,
  //updatedEffect: (stepIndex: number, methods: any) => void
  stepIndex: number,

  //screens: ReactJSXElement[],
  steps: StepType[],
  isUpdating: boolean,
  isLoading: boolean
  sx?: SxProps<Theme> | undefined
  wizardData: any

}


export const FormDataUpdateContext = React.createContext(undefined);

export const WizardDialog: React.FC<WizardDialogProps> = ({ defaultFormDataformData, formData, wizardData, updatedData, isLoading, isUpdating, open, onClose, updateStep: UpdateStep, handleSkip, handleBack, stepIndex, steps: wizardSteps, sx }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const contentRef = useRef<HTMLDivElement>(null);
  const [showScrollHint, setShowScrollHint] = useState(false);

  // State to control nextPressed flag
  const [includeNextPressed, setIncludeNextPressed] = useState(0);
  // Current step component publishes its async in-flight state here (e.g.,
  // SmsPhoneValidation flips this true during SMS send/verify). We hide the
  // Next button while busy to prevent confusing double-click attempts.
  const [stepBusy, setStepBusy] = useState(false);
  // Current step component can register a back handler to intercept the
  // wizard's Back button. When non-null, Back calls this instead of decrementing
  // stepIndex (e.g., SmsPhoneValidation registers handleBackToPhone while it's
  // in the 'code' sub-step so Back returns to the phone sub-step rather than
  // the previous wizard screen).
  const [stepBackHandler, setStepBackHandler] = useState<(() => void) | null>(null);

  const recheckScroll = useCallback(() => {
    const el = contentRef.current;
    if (!el) return;
    const isNearBottom = el.scrollHeight - el.scrollTop - el.clientHeight < 30;
    setShowScrollHint(!isNearBottom && el.scrollHeight > el.clientHeight + 50);
  }, []);

  const handleContentScroll = useCallback((e: React.UIEvent<HTMLDivElement>) => {
    const el = e.currentTarget;
    const isNearBottom = el.scrollHeight - el.scrollTop - el.clientHeight < 30;
    setShowScrollHint(!isNearBottom && el.scrollHeight > el.clientHeight + 50);
  }, []);

  const handleScrollDown = useCallback(() => {
    contentRef.current?.scrollTo({ top: contentRef.current.scrollHeight, behavior: 'smooth' });
  }, []);

  // Observe content size changes (e.g. collapsible sections expanding)
  const mutationObserverRef = useRef<MutationObserver | null>(null);
  const resizeObserverRef = useRef<ResizeObserver | null>(null);

  const handleContentMount = useCallback((el: HTMLDivElement | null) => {
    // Cleanup previous observers
    mutationObserverRef.current?.disconnect();
    resizeObserverRef.current?.disconnect();
    mutationObserverRef.current = null;
    resizeObserverRef.current = null;

    if (el) {
      (contentRef as React.MutableRefObject<HTMLDivElement>).current = el;
      requestAnimationFrame(() => {
        recheckScroll();
      });
      // Watch for DOM changes
      mutationObserverRef.current = new MutationObserver(() => {
        requestAnimationFrame(recheckScroll);
      });
      mutationObserverRef.current.observe(el, { childList: true, subtree: true, attributes: true });
      // Watch for size changes (CSS transitions like Collapse)
      resizeObserverRef.current = new ResizeObserver(() => {
        requestAnimationFrame(recheckScroll);
      });
      // Observe the scroll container and all direct children
      resizeObserverRef.current.observe(el);
      Array.from(el.children).forEach(child => {
        resizeObserverRef.current?.observe(child);
      });
    }
  }, [stepIndex, recheckScroll]);

  const methods = useForm<any>({ defaultValues: defaultFormDataformData })
  const { handleSubmit } = methods
  const { errors/*, isDirty, dirtyFields*/ } = methods.formState


  let isLastStep = stepIndex === wizardSteps.length - 1
  const GetArgs: (data: any, sumbitAattribute: string | undefined | null) => UpdateStepArgsType = (data, sumbitAattribute) => {
    const stepIndexUpdate: StepIndexUpdateType = { stepIndex: stepIndex, isUpdated: false, steps: [...wizardSteps] }
    return { formData: data, sumbitAattribute: sumbitAattribute, stepIndexUpdate: stepIndexUpdate, methods }
  }

  const GetArgsWithNextPressed: (data: any, sumbitAattribute: string | undefined | null) => UpdateStepArgsType = (data, sumbitAattribute) => {
    const stepIndexUpdate: StepIndexUpdateType = { stepIndex: stepIndex, isUpdated: false, steps: [...wizardSteps] }
    return { formData: { ...data, nextPressed: includeNextPressed }, sumbitAattribute: sumbitAattribute, stepIndexUpdate: stepIndexUpdate, methods }
  }

  const onCloseLocal: () => void = () => {
    const args = GetArgs(null, undefined)
    onClose(args)
    if (args.stepIndexUpdate.isUpdated) {
      // setStepIndex(args.stepIndexUpdate.stepIndex + 1);
      // setWizardSteps( args.stepIndexUpdate.steps)
    }
  }
  const onSubmitProfile = async (data: any, event: any) => {
    let sumbitAattribute: string | null = null
    if (event) {
      const submitter = event.nativeEvent.submitter as HTMLButtonElement;
      sumbitAattribute = submitter.getAttribute('submit-attr');
      //console.log('Form data:', data);
      //console.log('Custom attribute:', sumbitAattribute);
    }

    // Set includeNextPressed to true for this submission (will be reset after)
    setIncludeNextPressed((includeNextPressed??0) + 1);

    const args = GetArgsWithNextPressed(data, sumbitAattribute)

    const updateStepRet = await UpdateStep(args)

    // Note: includeNextPressed is not reset here to allow controlled component pattern
  }

  const onSkipWizard = () => {
    if (handleSkip)
      handleSkip(methods)
  }

  const onError = (errors: any) => {
    // Focus on the first field with an error
    const firstError = Object.keys(errors)[0];
    methods.setFocus(firstError);
  };

  const buttonTitle = wizardSteps[stepIndex]?.buttonTitle ?? (isLastStep ? 'Finish' : 'Next')
  const autoSizeSX = wizardSteps[stepIndex]?.autoSizeDialog ? {
    width: undefined,
    maxWidth: undefined,
    height: undefined,
    maxHeight: undefined
  } : {}

  const bottomRightSX = wizardSteps[stepIndex]?.showBottomRight ? {
    zIndex: 1301,
  } : {}

  if (wizardSteps.length < (stepIndex + 1) || !wizardSteps[stepIndex]) {
    return null;
  }
  //not passing onClose={onClose}

  const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'Enter') {
      // Allow Enter in textareas for newlines
      const target = event.target as HTMLElement;
      if (target.tagName === 'TEXTAREA') return;
      event.preventDefault();
      handleSubmit(onSubmitProfile, onError)()
    }
  };

  const updatedDataWithNextPressed: any = { ...updatedData, nextPressed: includeNextPressed }

  return (

    <FormProvider {...methods}>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        PaperProps={{
          component: 'form',
          onSubmit: handleSubmit(onSubmitProfile, onError),
          autoComplete: 'off',
          style: {
            borderRadius: 16,
            backgroundColor: 'rgba(255, 255, 255, 0.85)',
            backdropFilter: 'blur(24px)',
            WebkitBackdropFilter: 'blur(24px)',
            boxShadow: '0 8px 32px rgba(80, 60, 160, 0.12), inset 0 0 0 1px rgba(164, 142, 233, 0.15)',
            border: 'none',
            position: 'relative',
          },
        }}
        sx={[
          {
            '& .MuiDialog-container': {
              alignItems: 'center',
              justifyContent: 'center',
            },
            // Global input styling within the wizard
            '& .MuiOutlinedInput-root': {
              borderRadius: '10px',
              backgroundColor: 'rgba(244, 240, 255, 0.45)',
              fontSize: '0.875rem',
              '& .MuiOutlinedInput-notchedOutline': {
                borderColor: 'rgba(164, 142, 233, 0.25)',
              },
              '&:hover .MuiOutlinedInput-notchedOutline': {
                borderColor: 'rgba(164, 142, 233, 0.45)',
              },
              '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                borderColor: '#656EFF',
                borderWidth: '1.5px',
              },
            },
            '& .MuiInputLabel-root': {
              fontSize: '0.85rem',
            },
            '& .MuiAutocomplete-inputRoot': {
              backgroundColor: 'rgba(244, 240, 255, 0.45)',
            },
          },
          ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
          autoSizeSX,
          bottomRightSX,
        ] as any}
      >
        {/* Inline loading bar */}
        <Fade in={isUpdating} unmountOnExit>
          <LinearProgress
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              zIndex: 10,
              height: 3,
              borderRadius: '16px 16px 0 0',
              backgroundColor: 'rgba(101, 110, 255, 0.08)',
              '& .MuiLinearProgress-bar': {
                background: 'linear-gradient(90deg, #656EFF, #8B5CF6)',
              },
            }}
          />
        </Fade>
        <DialogTitle sx={{ pb: 0.5, pt: 1.5, px: { xs: 1.5, sm: 2 } }}>
          <ProfileDialogTitle onBack={handleBack} onClose={onCloseLocal} noBackArrow={wizardSteps[stepIndex]?.noBackArrow || stepBusy} color={wizardSteps[stepIndex]?.titleColor} stepIndex={stepIndex} subtitle={wizardSteps[stepIndex]?.subTitle}>{wizardSteps[stepIndex]?.title} </ProfileDialogTitle>
          {!wizardSteps[stepIndex].noProgressBar && <StepProgressBar steps={wizardSteps} activeStep={stepIndex} />}
        </DialogTitle>
        <DialogContent
          ref={handleContentMount}
          onScroll={handleContentScroll}
          sx={{
            px: { xs: 2, sm: 3 }, py: 1,
            overflowX: 'hidden',
            '&::-webkit-scrollbar': { width: 5 },
            '&::-webkit-scrollbar-track': { background: 'transparent' },
            '&::-webkit-scrollbar-thumb': {
              background: 'rgba(101, 110, 255, 0.18)',
              borderRadius: 3,
              '&:hover': { background: 'rgba(101, 110, 255, 0.32)' },
            },
            scrollbarWidth: 'thin',
            scrollbarColor: 'rgba(101, 110, 255, 0.18) transparent',
          }}
        >
          <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-evenly', height: '100%', opacity: isUpdating ? 0.5 : 1, transition: 'opacity 0.2s', pointerEvents: isUpdating ? 'none' : 'auto', }}>
            {(formData && (!isLoading)) ? <QuestionsForm onKeyDown={handleKeyDown} steps={wizardSteps} stepIndex={stepIndex} isLastStep={isLastStep} data={formData} wizardData={wizardData}
            updatedData={updatedDataWithNextPressed}
            isLoading={isLoading} isUpdating={isUpdating}
            onSubmitProfile={onSubmitProfile}
            setStepBusy={setStepBusy}
            setStepBackHandler={setStepBackHandler}
            //  resetNextPressed={() => {
            //   setTimeout(() => setIncludeNextPressed(false), 100)
            // }} nextPressed={includeNextPressed} 
            />
              : <CircularProgressCentered />}
            <ErrorMessage
              errors={errors}
              name="root.serverError"
              render={({ message }) => <> <Box sx={{ mt: 4,  display: 'flex', flexDirection: 'row',  justifyContent: 'center',   alignItems: 'flex-end',  }}> <WarningAmberIcon color='error' /><Typography sx={{ ml: '2px' }} variant='subtitle2' color='error'>{message} </Typography></Box></>}
            />
          </Box>

        </DialogContent>
        {/* Scroll-down chevron + fade gradient */}
        <Fade in={showScrollHint}>
          <Box sx={{
            display: 'flex',
            justifyContent: 'center',
            position: 'relative',
            height: 0,
            overflow: 'visible',
            zIndex: 2,
            // Gradient fade at bottom of content
            '&::before': {
              content: '""',
              position: 'absolute',
              bottom: 0,
              left: 0,
              right: 0,
              height: 40,
              background: 'linear-gradient(transparent, rgba(255,255,255,0.85))',
              pointerEvents: 'none',
            },
          }}>
            <IconButton
              onClick={handleScrollDown}
              size="small"
              sx={{
                position: 'absolute',
                bottom: -4,
                width: 28,
                height: 28,
                backgroundColor: 'rgba(255,255,255,0.95)',
                border: '1px solid rgba(164, 142, 233, 0.25)',
                boxShadow: '0 2px 8px rgba(80, 60, 160, 0.12)',
                animation: 'bounceDown 2s ease-in-out infinite',
                '@keyframes bounceDown': {
                  '0%, 100%': { transform: 'translateY(0)' },
                  '50%': { transform: 'translateY(3px)' },
                },
                '&:hover': {
                  backgroundColor: 'rgba(244, 240, 255, 0.95)',
                },
              }}
            >
              <KeyboardArrowDownIcon sx={{ color: '#656EFF', fontSize: 18 }} />
            </IconButton>
          </Box>
        </Fade>
        <DialogActions sx={{ gap: 2, px: { xs: 2, sm: 3 }, pb: 2, pt: 1 }}>

          {wizardSteps[stepIndex].skipLink && <Button id="pin_skip_link" disabled={stepBusy} disableElevation sx={{
            textTransform: "none",
            fontWeight: "normal",
            color: "primary.main",
            p: 0,
            minWidth: 0,
            backgroundColor: "transparent",
            boxShadow: "none",
            "&:hover": {
              backgroundColor: "transparent",
              textDecoration: "underline",
            },
            "&:focus": {
              backgroundColor: "transparent",
              outline: "none",
            },
            "&:active": {
              backgroundColor: "transparent",
            },
          }}
            variant="contained" onClick={() => onSkipWizard()}>
            {wizardSteps[stepIndex].skipLink}

          </Button>}
          <Box sx={{ display: 'flex', gap: 1.5, width: '100%', justifyContent: 'flex-end' }}>
            {stepIndex > 0 && !wizardSteps[stepIndex]?.noBackArrow && (
              <Button disabled={stepBusy} disableElevation onClick={() => (stepBackHandler ? stepBackHandler() : handleBack())} sx={{
                textTransform: 'none',
                fontWeight: 500,
                borderRadius: 8,
                px: 3,
                py: 0.75,
                color: '#656EFF',
                border: '1.5px solid rgba(101, 110, 255, 0.3)',
                backgroundColor: 'transparent',
                '&:hover': {
                  backgroundColor: 'rgba(101, 110, 255, 0.06)',
                  borderColor: '#656EFF',
                },
              }} variant="outlined" >
                Back
              </Button>
            )}
            {!wizardSteps[stepIndex].noButton && <Button id="pin_next_button" type="submit" disabled={stepBusy} disableElevation sx={{
              textTransform: 'none',
              fontWeight: 600,
              borderRadius: 8,
              background: 'linear-gradient(135deg, #656EFF 0%, #8B5CF6 100%)',
              px: 4,
              py: 0.75,
              boxShadow: '0 2px 8px rgba(101, 110, 255, 0.3)',
              '&:hover': {
                background: 'linear-gradient(135deg, #5A63E6 0%, #7C4FE0 100%)',
                boxShadow: '0 4px 12px rgba(101, 110, 255, 0.4)',
              },
            }} variant="contained" >
              {buttonTitle}
            </Button>}
          </Box>

        </DialogActions>

      </Dialog >

    </FormProvider >


  );
};

